module.exports = __webpack_public_path__ + "static/media/ic-nav-holdings-active.0f7c6424.svg";